export default __webpack_public_path__ + "static/media/linkedin-gray.ec0d4ca8.svg";